/* ========================================================================
   JavaScript personnalisé pour le thème Shopify
   ======================================================================== */

// Configuration
const SUBSCRIPTION_VARIANT_ID = 53229083820372;
const SUBSCRIPTION_PRODUCT_ID = 12436719894868;
const LANG_PREFIX = '' !== 'fr' ? '/' : '';

/* ========================================================================
   Utilitaires pour les animations de boutons
   ======================================================================== */

// Ajouter l'animation de chargement à un bouton
function startButtonLoading(button) {
  if (!button) return;
  button.classList.add('button-loading');
  button.disabled = true;
}

// Retirer l'animation de chargement d'un bouton
function stopButtonLoading(button) {
  if (!button) return;
  button.classList.remove('button-loading');
  button.disabled = false;
}

/* ========================================================================
   Logique du panier - Validation et redirection
   ======================================================================== */

// Intercepter le bouton checkout
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM chargé, initialisation bouton checkout');
  
  const checkoutBtn = document.querySelector('[type="submit"][name="checkout"]');
  console.log('Bouton checkout trouvé:', checkoutBtn);
  
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', async function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('Bouton checkout cliqué');
      
      // Vérifier que l'adresse est remplie
      const requiredFields = [
        'ship_first_name', 'ship_last_name', 'ship_address1',
        'ship_postal_code', 'ship_city', 'ship_country', 'ship_email'
      ];
      
      let allFilled = true;
      
      for (let fieldId of requiredFields) {
        const field = document.getElementById(fieldId);
        if (!field || !field.value.trim()) {
          allFilled = false;
          if (field) {
            field.style.border = '2px solid red';
            field.style.backgroundColor = '#fff5f5';
          }
        } else {
          if (field) {
            field.style.border = '';
            field.style.backgroundColor = '';
          }
        }
      }
      
      if (!allFilled) {
        alert('Veuillez remplir tous les champs obligatoires de livraison');
        const firstEmpty = requiredFields.find(id => {
          const f = document.getElementById(id);
          return f && !f.value.trim();
        });
        if (firstEmpty) {
          document.getElementById(firstEmpty).scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      
      console.log('Tous les champs sont remplis');
      
      // Désactiver le bouton pendant le traitement
      const btn = this;
      startButtonLoading(btn);
      const originalText = btn.textContent;
      btn.textContent = window.CART_TEXTS?.verifying || 'Vérification...';
      
      try {
        // 1. Valider les informations client avec customer_info.php
        console.log('Validation des informations client avec API...');
        
        const customerInfoResponse = await fetch('https://developer.gemmose.com/customer_info.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            emailAddress: document.getElementById('ship_email').value.trim(),
            shippingFirstName: document.getElementById('ship_first_name').value.trim(),
            shippingLastName: document.getElementById('ship_last_name').value.trim(),
            shippingAddress1: document.getElementById('ship_address1').value.trim(),
            shippingAddress2: document.getElementById('ship_address2').value.trim(),
            shippingPostalCode: document.getElementById('ship_postal_code').value.trim(),
            shippingCity: document.getElementById('ship_city').value.trim(),
            shippingCountry: document.getElementById('ship_country').value,
            phone: document.getElementById('ship_phone').value.trim(),
            timestamp: Date.now(),
            locale_code: window.getLocaleCode ? window.getLocaleCode() : 'fr'
          })
        });
        
        const customerInfoData = await customerInfoResponse.json();
        console.log('Réponse customer_info.php:', customerInfoData);
        
        // Si la validation échoue, afficher les erreurs
        if (!customerInfoData.success) {
          stopButtonLoading(btn);
          btn.textContent = originalText;
          
          // Afficher le message d'erreur global
          if (customerInfoData.message) {
            alert(customerInfoData.message);
          }
          
          // Mettre en évidence les champs en erreur
          if (customerInfoData.errors) {
            for (const [field, errorMsg] of Object.entries(customerInfoData.errors)) {
              // Convertir le nom du champ API vers l'ID du champ HTML
              const fieldMapping = {
                'emailAddress': 'ship_email',
                'shippingFirstName': 'ship_first_name',
                'shippingLastName': 'ship_last_name',
                'shippingAddress1': 'ship_address1',
                'shippingAddress2': 'ship_address2',
                'shippingPostalCode': 'ship_postal_code',
                'shippingCity': 'ship_city',
                'shippingCountry': 'ship_country',
                'phone': 'ship_phone'
              };
              
              const htmlFieldId = fieldMapping[field] || field;
              const inputField = document.getElementById(htmlFieldId);
              
              if (inputField) {
                inputField.style.border = '2px solid red';
                inputField.style.backgroundColor = '#fff5f5';
                
                // Créer un message d'erreur sous le champ si pas déjà présent
                const existingError = inputField.parentElement.querySelector('.field-error');
                if (!existingError) {
                  const errorDiv = document.createElement('div');
                  errorDiv.className = 'field-error';
                  errorDiv.style.color = 'red';
                  errorDiv.style.fontSize = '12px';
                  errorDiv.style.marginTop = '5px';
                  errorDiv.textContent = errorMsg;
                  inputField.parentElement.appendChild(errorDiv);
                }
              }
            }
          }
          
          // Si des suggestions d'adresse sont proposées
          if (customerInfoData.showSuggestions && customerInfoData.addressSuggestions) {
            // Afficher les suggestions au client (peut être amélioré avec un modal)
            const suggestions = customerInfoData.addressSuggestions.map((s, i) => 
              `${i+1}. ${s.street}, ${s.postcode} ${s.city}`
            ).join('\n');
            alert(`Veuillez vérifier votre adresse. Suggestions :\n\n${suggestions}`);
          }
          
          return;
        }
        
        console.log('Validation réussie, mise à jour du panier...');
        btn.textContent = window.CART_TEXTS?.processing || 'Traitement...';
                
        // Construire l'objet des attributs (formulaire + réinitialisation)
        const attributes = {
          ship_email: document.getElementById('ship_email').value.trim(),
          ship_phone: document.getElementById('ship_phone').value.trim(),
          ship_first_name: document.getElementById('ship_first_name').value.trim(),
          ship_last_name: document.getElementById('ship_last_name').value.trim(),
          ship_address1: document.getElementById('ship_address1').value.trim(),
          ship_address2: document.getElementById('ship_address2').value.trim(),
          ship_postal_code: document.getElementById('ship_postal_code').value.trim(),
          ship_city: document.getElementById('ship_city').value.trim(),
          ship_country: document.getElementById('ship_country').value,
          // Réinitialisation des données
          originalCampaignId: '39',
          forceMerchantId: '',
          shipProfileId: '49',
          has_active_member_subscription: '0',
          pixel: ''
        };
        
        console.log('Mise à jour du panier avec attributs et réinitialisation en un seul appel');
        
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
        
        // Vider les pixels du sessionStorage
        sessionStorage.removeItem('fb_pixels');
        
        console.log('Données de load-balancing réinitialisées, traitement de la logique de redirection');
        
        // 3. Maintenant gérer la logique de redirection
        await handleCartCheckout();
        
      } catch (error) {
        console.error('Error updating cart:', error);
        alert('Une erreur est survenue : ' + error.message);
        stopButtonLoading(btn);
        btn.textContent = originalText;
      }
    });
    
    console.log('Event listener ajouté au bouton submit[name="checkout"]');
  } else {
    console.error('Bouton [type="submit"][name="checkout"] non trouvé');
  }
});

// Fonction séparée pour la logique de redirection
async function handleCartCheckout() {
  try {
    console.log('handleCartCheckout appelé');
    
    // Récupérer le panier
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    
    console.log('Panier récupéré:', cart);
    
    // Vérifier si l'abonnement est dans le panier
    const hasSubscription = cart.items.some(item => item.variant_id === SUBSCRIPTION_VARIANT_ID);
    
    console.log('A un abonnement dans le panier:', hasSubscription);
    
    // Vérifier si le client est connecté à NOTRE compte client (via localStorage)
    let isLoggedIn = false;
    let hasActiveSubscription = false;
    
    const storedAccountData = localStorage.getItem('customerAccountData');
    if (storedAccountData) {
      try {
        const parsed = JSON.parse(storedAccountData);
        console.log('Données compte client trouvées dans localStorage:', parsed);
        
        // Vérifier si les données ne sont pas expirées (24h)
        const now = Date.now();
        const age = now - (parsed.timestamp || 0);
        
        if (age < 86400000 && parsed.data && parsed.data.purchase) {
          isLoggedIn = true;
          
          // Vérifier si l'abonnement est actif
          const subscriptionStatus = parsed.data.purchase.status;
          hasActiveSubscription = ['ACTIVE', 'TRIAL', 'RECYCLE_BILLING'].includes(subscriptionStatus);
          
          console.log('Client connecté via localStorage:', isLoggedIn);
          console.log('Statut abonnement:', subscriptionStatus);
          console.log('A un abonnement actif:', hasActiveSubscription);
        }
      } catch (e) {
        console.error('Erreur parsing localStorage:', e);
      }
    }
    
    // Si pas connecté ou pas de tag, vérifier via API
    if (!hasActiveSubscription && cart.attributes.ship_email) {
      console.log('Vérification via API pour:', cart.attributes.ship_email);
      
      try {
        const subCheckResponse = await fetch('https://developer.gemmose.com/subscription_check.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: cart.attributes.ship_email,
            domaine: window.location.hostname,
            timestamp: Date.now(),
            locale_code: window.getLocaleCode ? window.getLocaleCode() : 'fr'
          })
        });
        
        const subCheckData = await subCheckResponse.json();
        hasActiveSubscription = subCheckData.success === true;
        console.log('Résultat API subscription_check:', subCheckData, '-> hasActiveSubscription:', hasActiveSubscription);
      } catch (error) {
        console.error('Erreur lors de la vérification API:', error);
      }
    }
    
    console.log('Décision de redirection - hasActiveSubscription:', hasActiveSubscription, 'hasSubscription:', hasSubscription);
    
    // Stocker dans les attributs du panier si le client a des avantages membre
    const hasMemberBenefits = hasActiveSubscription || hasSubscription;
    
    if (hasMemberBenefits) {
      console.log('Client avec avantages membre, ajout attribut au panier...');
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            has_active_member_subscription: '1'
          }
        })
      });
      console.log('Attribut has_active_member_subscription ajouté au panier');
    }
    
    // Utiliser window.LANG_PREFIX défini dans theme.liquid
    const LANG_PREFIX = window.LANG_PREFIX || '';
    console.log('LANG_PREFIX utilisé:', LANG_PREFIX);
    
    // Logique de redirection
    if (hasActiveSubscription) {
      console.log('Client avec abonnement actif (connecté=' + isLoggedIn + ') -> checkout');
      // Retirer l'abonnement du panier si présent (car déjà abonné)
      if (hasSubscription) {
        console.log('Retrait de l\'abonnement du panier car déjà abonné');
        await removeSubscriptionFromCart(cart);
      }
      // Rediriger vers le checkout
      window.location.href = LANG_PREFIX + '/pages/checkout';
      
    // CAS 2 : L'abonnement est dans le panier
    } else if (hasSubscription) {
      console.log('Abonnement dans le panier -> checkout');
      // A l'abonnement dans le panier : aller au checkout
      window.location.href = LANG_PREFIX + '/pages/checkout';
      
    // CAS 3 : Aucun avantage membre
    } else {
      console.log('Aucun abonnement -> upsell');
      // Aucun abonnement : rediriger vers l'upsell
      window.location.href = LANG_PREFIX + '/pages/offre-exclusive';
    }
    
  } catch (error) {
    console.error('Error in checkout logic:', error);
    alert('Une erreur est survenue : ' + error.message);
  }
}

async function removeSubscriptionFromCart(cart) {
  try {
    // Trouver la ligne de l'abonnement
    const subIndex = cart.items.findIndex(item => item.variant_id === SUBSCRIPTION_VARIANT_ID);
    if (subIndex !== -1) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: subIndex + 1,
          quantity: 0
        })
      });
    }
  } catch (error) {
    console.error('Error removing subscription:', error);
  }
}

/* ========================================================================
   Page Upsell - Ajout de l'abonnement au panier
   ======================================================================== */

if (document.getElementById('add-subscription-btn')) {
  document.getElementById('add-subscription-btn').addEventListener('click', async function() {
    const btn = this;
    startButtonLoading(btn);
    
    try {
      const langPrefix = window.LANG_PREFIX || '';
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: SUBSCRIPTION_VARIANT_ID,
          quantity: 1
        })
      });
      
      window.location.href = langPrefix + '/pages/checkout';
    } catch (error) {
      console.error('Error adding subscription:', error);
      alert('Une erreur est survenue');
      stopButtonLoading(btn);
    }
  });
}

if (document.getElementById('skip-subscription-btn')) {
  document.getElementById('skip-subscription-btn').addEventListener('click', async function() {
    const btn = this;
    startButtonLoading(btn);
    
    try {
      console.log('Client choisit livraison payante - retrait abonnement et avantages');
      
      const langPrefix = window.LANG_PREFIX || '';
      
      // 1. Récupérer le panier actuel
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // 2. Retirer l'abonnement du panier s'il y est
      const subIndex = cart.items.findIndex(item => item.variant_id === SUBSCRIPTION_VARIANT_ID);
      if (subIndex !== -1) {
        console.log('Retrait de l\'abonnement du panier');
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: subIndex + 1,
            quantity: 0
          })
        });
      }
      
      // 3. Supprimer l'attribut des avantages membre pour forcer la livraison payante
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            has_active_member_subscription: '' // Vide = suppression
          }
        })
      });
      
      console.log('Attributs membre supprimés, redirection vers checkout');
      
      // 4. Rediriger vers le checkout
      window.location.href = langPrefix + '/pages/checkout';
      
    } catch (error) {
      console.error('Error handling skip subscription:', error);
      alert('Une erreur est survenue');
      stopButtonLoading(btn);
    }
  });
}

/* ========================================================================
   Page Checkout - Gestion du paiement
   ======================================================================== */

// Fonction pour envoyer le partial
window.sendCheckoutPartial = async function() {
  if (!window.checkoutData || !window.checkoutData.cartData) {
    console.log('Pas de données de panier disponibles pour le partial');
    return;
  }
  
  try {
    const metaResponse = await fetch('/cart?view=meta-data.json');
    const metaData = await metaResponse.json();
    
    const productsString = buildProductsString(metaData.meta_product_id_array);
    const cart = window.checkoutData.cartData;
    
    const partialData = {
      products: productsString,
      cartId: 'cart_' + Date.now(),
      firstName: cart.attributes.ship_first_name || '',
      lastName: cart.attributes.ship_last_name || '',
      address1: cart.attributes.ship_address1 || '',
      address2: cart.attributes.ship_address2 || '',
      postalCode: cart.attributes.ship_postal_code || '',
      city: cart.attributes.ship_city || '',
      country: cart.attributes.ship_country || '',
      emailAddress: cart.attributes.ship_email || '',
      phoneNumber: cart.attributes.ship_phone || '',
      ipAddress: '',
      shipFirstName: cart.attributes.ship_first_name || '',
      shipLastName: cart.attributes.ship_last_name || '',
      shipAddress1: cart.attributes.ship_address1 || '',
      shipAddress2: cart.attributes.ship_address2 || '',
      shipPostalCode: cart.attributes.ship_postal_code || '',
      shipCity: cart.attributes.ship_city || '',
      shipCountry: cart.attributes.ship_country || '',
      billShipSame: '1',
      custom1: window.location.hostname,
      custom2: 'checkout',
      custom3: 'order-confirmed',
      custom4: '',
      custom5: '',
      campaignId: window.checkoutData.campaignId,
      originalCampaignId: window.checkoutData.getOriginalCampaignId(),
      checkoutUrl: window.location.href,
      locale_code: window.getLocaleCode ? window.getLocaleCode() : 'fr'
    };
    
    const response = await fetch('https://developer.gemmose.com/send_partial.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(partialData)
    });
    
    const result = await response.json();
    console.log('Partial envoyé:', result);
    
  } catch (error) {
    console.error('Erreur lors de l\'envoi du partial:', error);
  }
};

// Gestion du paiement
if (document.getElementById('submit-payment-btn')) {
  document.getElementById('submit-payment-btn').addEventListener('click', async function() {
    const btn = this;
    const errorDiv = document.getElementById('payment-error');
    errorDiv.style.display = 'none';
    
    // Vérifier l'acceptation des CGV
    const acceptTerms = document.getElementById('accept-terms');
    const termsError = document.getElementById('terms-error');
    
    if (acceptTerms && !acceptTerms.checked) {
      if (termsError) {
        termsError.style.display = 'block';
      }
      acceptTerms.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    
    if (termsError) {
      termsError.style.display = 'none';
    }
    
    // Validation
    const cardNumber = document.getElementById('card_number').value.replace(/\s/g, '');
    const cardMonth = document.getElementById('card_expiry_month').value.padStart(2, '0');
    const cardYear = document.getElementById('card_expiry_year').value;
    const cardCVV = document.getElementById('card_cvv').value;
    
    // Validation des champs
    let hasError = false;
    let errorMsg = '';
    
    if (!cardNumber || cardNumber.length < 13 || cardNumber.length > 19) {
      hasError = true;
      errorMsg = 'Numéro de carte invalide';
      document.getElementById('card_number').classList.add('error');
    }
    
    if (!cardMonth || parseInt(cardMonth) < 1 || parseInt(cardMonth) > 12) {
      hasError = true;
      errorMsg = 'Mois d\'expiration invalide';
      document.getElementById('card_expiry_month').classList.add('error');
    }
    
    if (!cardYear || cardYear.length !== 4) {
      hasError = true;
      errorMsg = 'Année d\'expiration invalide';
      document.getElementById('card_expiry_year').classList.add('error');
    }
    
    if (!cardCVV || cardCVV.length < 3 || cardCVV.length > 4) {
      hasError = true;
      errorMsg = 'Code CVV invalide';
      document.getElementById('card_cvv').classList.add('error');
    }
    
    if (hasError) {
      errorDiv.textContent = errorMsg;
      errorDiv.style.display = 'block';
      return;
    }
    
    // Désactiver le bouton
    startButtonLoading(btn);
    document.getElementById('btn-text').style.display = 'none';
    document.getElementById('btn-loader').style.display = 'inline';
    
    try {
      // Calculer le total pour Facebook
      const cartResponse = await fetch('/cart.js');
      const currentCart = await cartResponse.json();
      const totalPrice = currentCart.total_price / 100;
      
      // Envoyer AddPaymentInfo à Facebook si pixels présents
      if (typeof window.sendFacebookAddPaymentInfo === 'function') {
        await window.sendFacebookAddPaymentInfo(totalPrice);
      }
      
      const metaResponse = await fetch('/cart?view=meta-data.json');
      const metaData = await metaResponse.json();
      const productsString = buildProductsString(metaData.meta_product_id_array);
      const cart = window.checkoutData.cartData;
      
      const orderData = {
        products: productsString,
        cartId: 'cart_' + Date.now(),
        firstName: cart.attributes.ship_first_name || '',
        lastName: cart.attributes.ship_last_name || '',
        address1: cart.attributes.ship_address1 || '',
        address2: cart.attributes.ship_address2 || '',
        postalCode: cart.attributes.ship_postal_code || '',
        city: cart.attributes.ship_city || '',
        country: cart.attributes.ship_country || '',
        emailAddress: cart.attributes.ship_email || '',
        phoneNumber: cart.attributes.ship_phone || '',
        ipAddress: '',
        shipFirstName: cart.attributes.ship_first_name || '',
        shipLastName: cart.attributes.ship_last_name || '',
        shipAddress1: cart.attributes.ship_address1 || '',
        shipAddress2: cart.attributes.ship_address2 || '',
        shipPostalCode: cart.attributes.ship_postal_code || '',
        shipCity: cart.attributes.ship_city || '',
        shipCountry: cart.attributes.ship_country || '',
        billShipSame: '1',
        cardNumber: cardNumber,
        cardMonth: cardMonth,
        cardYear: cardYear,
        cardSecurityCode: cardCVV,
        paySource: 'CREDITCARD',
        browserData: document.getElementById('browserData').value,
        redirectsTo: 'https://developer.gemmose.com/thank_you_redirect.php',
        errorRedirectsTo: window.location.href,
        custom1: window.location.hostname,
        custom2: 'checkout',
        custom3: 'order-confirmed',
        custom4: '',
        custom5: '',
        campaignId: window.checkoutData.campaignId,
        originalCampaignId: window.checkoutData.getOriginalCampaignId()
      };
      
      // Ajouter forceMerchantId si présent
      const forceMerchantId = window.checkoutData.getForceMerchantId();
      if (forceMerchantId) {
        orderData.forceMerchantId = forceMerchantId;
      }
      
      // Construire l'URL
      let apiUrl = 'https://developer.gemmose.com/send_order.php';
      
      // Ajouter locale_code en premier
      apiUrl += '?locale_code=' + encodeURIComponent(window.getLocaleCode ? window.getLocaleCode() : 'fr');
      
      // Ajouter shipProfile ou couponCode selon les avantages
      if (window.checkoutData.hasMemberBenefits) {
        apiUrl += '&couponCode=' + encodeURIComponent('MEMBRE,FREE');
      } else {
        // Utiliser shipProfileId depuis les attributs du panier ou valeur par défaut
        orderData.shipProfile = window.checkoutData.getShipProfileId();
      }
      
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(orderData)
      });
      
      const result = await response.json();
      console.log('Résultat du paiement:', result);
      
      // Traiter la réponse
      switch (result.result) {
        case 'SUCCESS':
          // Vider le panier
          await fetch('/cart/clear.js', { method: 'POST' });
          // Rediriger vers thank you
          window.location.href = 'https://developer.gemmose.com/thank_you_redirect.php?orderData=' + encodeURIComponent(JSON.stringify(result.message));
          break;
          
        case 'ERROR':
          errorDiv.textContent = result.message || 'Une erreur est survenue lors du paiement. Veuillez vérifier vos informations.';
          errorDiv.style.display = 'block';
          stopButtonLoading(btn);
          document.getElementById('btn-text').style.display = 'inline';
          document.getElementById('btn-loader').style.display = 'none';
          break;
          
        case 'MERC_REDIRECT':
          if (result.message.url) {
            window.location.href = result.message.url;
          } else if (result.message.script) {
            eval(result.message.script);
          }
          break;
          
        default:
          console.error('Réponse inconnue:', result);
          errorDiv.textContent = 'Réponse inattendue du serveur';
          errorDiv.style.display = 'block';
          stopButtonLoading(btn);
          document.getElementById('btn-text').style.display = 'inline';
          document.getElementById('btn-loader').style.display = 'none';
      }
      
    } catch (error) {
      console.error('Erreur lors du paiement:', error);
      errorDiv.textContent = 'Une erreur est survenue. Veuillez réessayer.';
      errorDiv.style.display = 'block';
      stopButtonLoading(btn);
      document.getElementById('btn-text').style.display = 'inline';
      document.getElementById('btn-loader').style.display = 'none';
    }
  });
}

function buildProductsString(products) {
  let productsUrl = '';
  let index = 1;
  
  products.forEach(item => {
    if (!item.id) return;
    
    const productId = item.id.includes('.') ? item.id.split('.')[0] : item.id;
    const variantId = item.id.includes('.') ? item.id.split('.')[1] : null;
    
    let price = (item.price / 100).toFixed(2);
    
    if (item.is_subscription) {
      price = '0.00';
    }
    
    const shipPrice = '0.00';
    
    productsUrl += `&product${index}_id=${productId}`;
    if (variantId) {
      productsUrl += `&variant${index}_id=${variantId}`;
    }
    productsUrl += `&product${index}_qty=${item.quantity}`;
    productsUrl += `&product${index}_price=${price}`;
    productsUrl += `&product${index}_shipPrice=${shipPrice}`;
    
    index++;
  });
  
  return productsUrl;
}

/* ========================================================================
   Utilitaires
   ======================================================================== */

function formatMoney(cents, format) {
  if (typeof cents === 'string') { cents = cents.replace('.', ''); }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || '€';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number == null) { return '0'; }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsAmount = parts[1] ? (decimal + parts[1]) : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2, ' ', ',');
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0, ' ', ',');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

// Rendre disponible globalement
window.formatMoney = formatMoney;

